import {
  apiClient,
  Auth,
  Pagination,
  PaginationSearchParams,
} from '@/shared/api'

import { TMasterContractStatus, TGuestMasterContract } from '../model/schema'

export type GuestMasterContractsSearchParams = Pick<
  PaginationSearchParams,
  'page'
> & {
  contractMasterStatus?: TMasterContractStatus
}

export const getGuestMasterContracts = async (
  params: GuestMasterContractsSearchParams,
) => {
  const response = await apiClient.get<Pagination<TGuestMasterContract>>({
    endpoint: `/guest/contracts/masters`,
    queryParams: {
      ...params,
      size: 10,
    },
    auth: Auth.REQUIRED,
  })

  return response
}
